import MenuOutlined from '@mui/icons-material/MenuOutlined';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import { ReactNode } from 'react';

type Props = {
  isOpen: boolean;
  children: ReactNode;
  onToggle: () => void;
};

export const SidebarContainer = ({ isOpen, children, onToggle }: Props) => {
  return (
    <Box
      sx={[
        {
          display: 'grid',
          minHeight: 'calc(100dvh - 63px)',
          position: 'relative',
          gridTemplateColumns: !isOpen ? 'auto 0' : `auto 420px`,
        },
        (theme) => ({
          transition: '300ms',
          [theme.breakpoints.down('md')]: {
            gridTemplateColumns: 'auto 0',
          },
        }),
      ]}
    >
      {children}
      <Box
        sx={{
          position: 'absolute',
          top: 12,
          right: 8,
        }}
      >
        <IconButton onClick={onToggle}>
          <MenuOutlined />
        </IconButton>
      </Box>
    </Box>
  );
};
